// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import f from "./components/footer";
import "swiper/swiper-bundle.css";
import common from "./utils/common.js";

import navigationbar from "./components/navigation_bar";
Vue.component("navigationbar", navigationbar);

Vue.config.productionTip = false;
Vue.component("kid-footer", f);

import "./assets/main.css";
import axios from "axios";
// axios.defaults.baseURL = "/api";

import Head from "@/components/head";

import Paginate from "@/components/Paginate";
Vue.component("Paginate", Paginate);
Vue.component("Head", Head);

import CxltToastr from "@/components/toast/index.js";

// import { getUser } from './utils/common'

Vue.use(CxltToastr);

import courseItem from "@/components/courseItem";
Vue.component("courseItem", courseItem);
import {
  getRequest,
  postRequest,
  getqr,
  postRequestVisit,
  getRequestVisit
} from "./utils/utils";

import 'jquery'

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.getRequestVisit = getRequestVisit;
Vue.prototype.getqr = getqr;
Vue.prototype.postRequestVisit = postRequestVisit;

/* 路由发生变化修改页面title */

router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }

  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?622d6e69b2b3c8a5b5bfb78b6ada57f7";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })()


  if (to.path.indexOf('/index') != -1 || to.path.indexOf('/company') != -1) {
    next()
  } else {
    if (common.userBase != null) {
      postRequestVisit('Api/v1/Log/VisitLog', {
        productIds: "3",
        sourceType: 'PC',
        moduleName: to.name,
        pageUrl: "https://kids.bjadks.com" + to.path,
        previousPageUrl: "https://kids.bjadks.com" + from.path,
        userId: common.userBase.UserId || common.getUser(),
        userName: common.userBase.UserName,
        customerCode: common.userBase.ComCode,
        customerName: common.userBase.ComName,
        customerId: common.userBase.ComId,
        actId: 0
      })
      next()
    } else {
      var token = common.getCookie('utoken');
      if (token != '') {
        var userInfor = getRequest('api/v1/User', {
          token: token
        }).then(data => {
          if (data.IsSuccess) {
            common.userBase = data.Data;
            postRequestVisit('Api/v1/Log/VisitLog', {
              productIds: "3",
              sourceType: 'PC',
              moduleName: to.name,
              pageUrl: "https://kids.bjadks.com" + to.path,
              previousPageUrl: "https://kids.bjadks.com" + from.path,
              userId: common.userBase.UserId || common.getUser(),
              userName: common.userBase.UserName,
              customerCode: common.userBase.ComCode,
              customerName: common.userBase.ComName,
              customerId: common.userBase.ComId,
              actId: 0

            })
            next()
          } else {
            postRequestVisit('Api/v1/Log/VisitLog', {
              productIds: "3",
              sourceType: 'PC',
              moduleName: to.name,
              pageUrl: "https://kids.bjadks.com" + to.path,
              previousPageUrl: "https://kids.bjadks.com" + from.path,
              userId: common.getUser(),
              userName: '',
              customerCode: '',
              customerName: '',
              customerId: 0,
              actId: 0
            })
            next()
          }
        })
      } else {
        postRequestVisit('Api/v1/Log/VisitLog', {
          productIds: "3",
          sourceType: 'PC',
          moduleName: to.name,
          pageUrl: "https://kids.bjadks.com" + to.path,
          previousPageUrl: "https://kids.bjadks.com" + from.path,
          userId: common.getUser(),
          userName: '',
          customerCode: '',
          customerName: '',
          customerId: 0,
          actId: 0
        })
        next()
      }
    }
  }
});
/* eslint-disable no-new */
var vue = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  data() {
    return {
      notification: new Vue()
    };
  }
});
export default vue;



// WEBPACK FOOTER //
// ./src/main.js